{
  "about.blocks": "Pelayan yang diselaraskan",
  "about.contact": "Hubungi:",
  "about.default_locale": "Lalai",
  "about.disclaimer": "Mastodon ialah perisian sumber terbuka percuma, dan merupakan tanda dagangan Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Sebab tidak tersedia",
  "about.domain_blocks.preamble": "Secara amnya, Mastodon membenarkan anda melihat kandungan pengguna daripada mana-mana pelayan dalam alam bersekutu dan berinteraksi dengan mereka. Berikut ialah pengecualian yang khusus pada pelayan ini.",
  "about.domain_blocks.silenced.explanation": "Secara amnya, anda tidak akan melihat profil dan kandungan daripada pelayan ini, kecuali anda mencarinya secara khusus atau ikut serta dengan mengikutinya.",
  "about.domain_blocks.silenced.title": "Terhad",
  "about.domain_blocks.suspended.explanation": "Tiada data daripada pelayan ini yang akan diproses, disimpan atau ditukar, menjadikan sebarang interaksi atau perhubungan dengan pengguna daripada pelayan ini adalah mustahil.",
  "about.domain_blocks.suspended.title": "Digantung",
  "about.language_label": "Bahasa",
  "about.not_available": "Maklumat ini belum tersedia pada pelayan ini.",
  "about.powered_by": "Media sosial terpencar yang dikuasakan oleh {mastodon}",
  "about.rules": "Peraturan pelayan",
  "account.account_note_header": "Catatan peribadi",
  "account.add_or_remove_from_list": "Tambah atau Buang dari senarai",
  "account.badges.bot": "Automatik",
  "account.badges.group": "Kumpulan",
  "account.block": "Sekat @{name}",
  "account.block_domain": "Sekat domain {domain}",
  "account.block_short": "Sekat",
  "account.blocked": "Disekat",
  "account.cancel_follow_request": "Batalkan permintaan ikut",
  "account.copy": "Salin pautan ke profil",
  "account.direct": "Sebut secara persendirian @{name}",
  "account.disable_notifications": "Berhenti maklumkan saya apabila @{name} mengirim hantaran",
  "account.edit_profile": "Sunting profil",
  "account.edit_profile_short": "Sunting",
  "account.enable_notifications": "Maklumi saya apabila @{name} mengirim hantaran",
  "account.endorse": "Tampilkan di profil",
  "account.familiar_followers_one": "melayuikutikut{name1}",
  "account.follow": "Ikuti",
  "account.follow_back": "Ikut balik",
  "account.followers": "Pengikut",
  "account.followers.empty": "Belum ada yang mengikuti pengguna ini.",
  "account.followers_counter": "{count, plural, one {{counter} pengikut} other {{counter} pengikut}}",
  "account.following": "Ikutan",
  "account.following_counter": "{count, plural, other {{counter} ikutan}}",
  "account.follows.empty": "Pengguna ini belum mengikuti sesiapa.",
  "account.go_to_profile": "Pergi ke profil",
  "account.hide_reblogs": "Sembunyikan galakan daripada @{name}",
  "account.in_memoriam": "Dalam kenangan.",
  "account.joined_short": "Tarikh penyertaan",
  "account.languages": "Tukar bahasa langganan",
  "account.link_verified_on": "Pemilikan pautan ini telah disemak pada {date}",
  "account.locked_info": "Taraf privasi akaun ini dikunci. Pemiliknya menyaring sendiri siapa yang boleh mengikutinya.",
  "account.media": "Media",
  "account.mention": "Sebut @{name}",
  "account.moved_to": "{name} telah menandakan bahawa akaun baru mereka sekarang ialah:",
  "account.mute": "Redamkan @{name}",
  "account.mute_notifications_short": "Redamkan pemberitahuan",
  "account.mute_short": "Redam",
  "account.muted": "Diredamkan",
  "account.no_bio": "Tiada penerangan diberikan.",
  "account.open_original_page": "Buka halaman asal",
  "account.posts": "Hantaran",
  "account.report": "Laporkan @{name}",
  "account.requested_follow": "{name} has requested to follow you",
  "account.share": "Kongsi profil @{name}",
  "account.show_reblogs": "Tunjukkan galakan daripada @{name}",
  "account.statuses_counter": "{count, plural, other {{counter} siaran}}",
  "account.unblock": "Nyahsekat @{name}",
  "account.unblock_domain": "Nyahsekat domain {domain}",
  "account.unblock_domain_short": "Nyahsekat",
  "account.unblock_short": "Nyahsekat",
  "account.unendorse": "Jangan tampilkan di profil",
  "account.unfollow": "Nyahikut",
  "account.unmute": "Nyahbisukan @{name}",
  "account.unmute_notifications_short": "Nyahredamkan pemberitahuan",
  "account.unmute_short": "Nyahredam",
  "account_note.placeholder": "Klik untuk menambah catatan",
  "admin.dashboard.daily_retention": "Kadar pengekalan pengguna mengikut hari selepas mendaftar",
  "admin.dashboard.monthly_retention": "Kadar pengekalan pengguna mengikut bulan selepas mendaftar",
  "admin.dashboard.retention.average": "Purata",
  "admin.dashboard.retention.cohort": "Bulan pendaftaran",
  "admin.dashboard.retention.cohort_size": "Pengguna baru",
  "admin.impact_report.instance_accounts": "Profil akaun ini akan dipadamkan",
  "admin.impact_report.instance_followers": "Pengikut pengguna kami akan hilang",
  "admin.impact_report.instance_follows": "Pengikut pengguna mereka akan hilang",
  "admin.impact_report.title": "Ringkasan kesan",
  "alert.rate_limited.message": "Sila cuba semula selepas {retry_time, time, medium}.",
  "alert.rate_limited.title": "Kadar terhad",
  "alert.unexpected.message": "Berlaku ralat di luar jangkaan.",
  "alert.unexpected.title": "Alamak!",
  "alt_text_badge.title": "Teks alternatif",
  "alt_text_modal.add_alt_text": "Tambah teks alternatif",
  "alt_text_modal.add_text_from_image": "Tambah teks dari imej",
  "alt_text_modal.cancel": "Batal",
  "alt_text_modal.change_thumbnail": "Ubah imej kecil",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Terangkan untuk OKU pendengaran…vorite\n",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Terangkan untuk OKU penglihatan…",
  "alt_text_modal.done": "Selesai",
  "announcement.announcement": "Pengumuman",
  "annual_report.summary.most_used_app.most_used_app": "aplikasi paling banyak digunakan",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "tanda pagar paling banyak digunakan",
  "annual_report.summary.new_posts.new_posts": "hantaran baharu",
  "annual_report.summary.percentile.text": "<topLabel>Anda berkedudukan</topLabel><percentage></percentage><bottomLabel> pengguna {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Rahsia anda selamat bersama kami. ;)",
  "attachments_list.unprocessed": "(belum diproses)",
  "audio.hide": "Sembunyikan audio",
  "block_modal.remote_users_caveat": "Kami akan meminta pelayan {domain} untuk menghormati keputusan anda. Bagaimanapun, pematuhan tidak dijamin kerana ada pelayan yang mungkin menangani sekatan dengan cara berbeza. Hantaran awam mungkin masih tampak kepada pengguna yang tidak log masuk.",
  "block_modal.show_less": "Tunjuk kurang",
  "block_modal.show_more": "Tunjuk lebih",
  "block_modal.they_will_know": "Dia boleh lihat bahawa dia disekat.",
  "block_modal.title": "Sekat pengguna?",
  "boost_modal.combo": "Anda boleh tekan {combo} untuk melangkauinya pada waktu lain",
  "boost_modal.reblog": "Galakkan hantaran?",
  "boost_modal.undo_reblog": "Nyahgalakkan hantaran?",
  "bundle_column_error.copy_stacktrace": "Salin laporan ralat",
  "bundle_column_error.error.body": "Halaman yang diminta gagal dipaparkan. Ini mungkin disebabkan oleh pepijat dalam kod kami, atau masalah keserasian pelayar.",
  "bundle_column_error.error.title": "Alamak!",
  "bundle_column_error.network.body": "Terdapat suatu ralat apabila cuba memuatkan halaman ini. Keadaan ini mungkin berlaku disebabkan oleh masalah pada sambungan internet anda atau pelayan ini.",
  "bundle_column_error.network.title": "Ralat rangkaian",
  "bundle_column_error.retry": "Cuba lagi",
  "bundle_column_error.return": "Kembali ke halaman utama",
  "bundle_column_error.routing.body": "Halaman tersebut tidak dapat ditemui. Adakah anda pasti URL dalam bar alamat adalah betul?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Tutup",
  "bundle_modal_error.message": "Terdapat masalah yang dihadapi ketika memuat layar ini.",
  "bundle_modal_error.retry": "Cuba lagi",
  "closed_registrations.other_server_instructions": "Oleh sebab Mastodon terpencar, anda boleh mencipta akaun pada pelayan lain dan masih berinteraksi dengan pelayan ini.",
  "closed_registrations_modal.description": "Mencipta akaun pada {domain} tidak dapat dibuat sekarang, tetapi sila ingat bahawa anda tidak memerlukan akaun khususnya pada {domain} untuk menggunakan Mastodon.",
  "closed_registrations_modal.find_another_server": "Cari pelayan lain",
  "closed_registrations_modal.preamble": "Mastodon adalah terpencar, oleh itu di mana-mana anda mencipta akaun anda, anda boleh mengikut dan berinteraksi dengan sesiapa pada pelayan ini. Anda juga boleh hos sendiri!",
  "closed_registrations_modal.title": "Mendaftar pada Mastodon",
  "column.about": "Perihal",
  "column.blocks": "Pengguna tersekat",
  "column.bookmarks": "Tanda buku",
  "column.community": "Garis masa tempatan",
  "column.create_list": "Cipta senarai",
  "column.direct": "Sebutan peribadi",
  "column.directory": "Layari profil",
  "column.domain_blocks": "Domain tersekat",
  "column.edit_list": "Sunting senarai",
  "column.favourites": "Sukaan",
  "column.firehose": "Suapan langsung",
  "column.follow_requests": "Permintaan ikutan",
  "column.home": "Laman Utama",
  "column.list_members": "Urus ahli senarai",
  "column.lists": "Senarai",
  "column.mutes": "Pengguna teredam",
  "column.notifications": "Pemberitahuan",
  "column.pins": "Hantaran disemat",
  "column.public": "Garis masa bersekutu",
  "column_back_button.label": "Kembali",
  "column_header.hide_settings": "Sembunyikan tetapan",
  "column_header.moveLeft_settings": "Pindah lajur ke kiri",
  "column_header.moveRight_settings": "Pindah lajur ke kanan",
  "column_header.pin": "Sematkan",
  "column_header.show_settings": "Tunjukkan tetapan",
  "column_header.unpin": "Nyahsemat",
  "column_search.cancel": "Batal",
  "community.column_settings.local_only": "Tempatan sahaja",
  "community.column_settings.media_only": "Media sahaja",
  "community.column_settings.remote_only": "Jauh sahaja",
  "compose.language.change": "Tukar bahasa",
  "compose.language.search": "Cari bahasa...",
  "compose.published.body": "Pos telah diterbitkan.",
  "compose.published.open": "Buka",
  "compose.saved.body": "Kiriman disimpan.",
  "compose_form.direct_message_warning_learn_more": "Ketahui lebih lanjut",
  "compose_form.encryption_warning": "Hantaran pada Mastodon tidak disulitkan hujung ke hujung. Jangan berkongsi sebarang maklumat sensitif melalui Mastodon.",
  "compose_form.hashtag_warning": "Hantaran ini tidak akan disenaraikan di bawah mana-mana tanda pagar kerana ia tidak tersenarai. Hanya hantaran awam sahaja boleh dicari menggunakan tanda pagar.",
  "compose_form.lock_disclaimer": "Akaun anda tidak {locked}. Sesiapa pun boleh mengikuti anda untuk melihat hantaran pengikut-sahaja anda.",
  "compose_form.lock_disclaimer.lock": "dikunci",
  "compose_form.placeholder": "Apakah yang sedang anda fikirkan?",
  "compose_form.poll.duration": "Tempoh undian",
  "compose_form.poll.multiple": "Pelbagai pilihan",
  "compose_form.poll.option_placeholder": "Pilihan {number}",
  "compose_form.poll.single": "Satu pilihan",
  "compose_form.poll.switch_to_multiple": "Ubah kepada membenarkan aneka undian",
  "compose_form.poll.switch_to_single": "Ubah kepada undian pilihan tunggal",
  "compose_form.poll.type": "Gaya",
  "compose_form.publish": "Siaran",
  "compose_form.reply": "Balas",
  "compose_form.save_changes": "Kemas kini",
  "compose_form.spoiler.marked": "Buang amaran kandungan",
  "compose_form.spoiler.unmarked": "Tambah amaran kandungan",
  "compose_form.spoiler_placeholder": "Amaran kandungan (pilihan)",
  "confirmation_modal.cancel": "Batal",
  "confirmations.block.confirm": "Sekat",
  "confirmations.delete.confirm": "Padam",
  "confirmations.delete.message": "Adakah anda pasti anda ingin memadam hantaran ini?",
  "confirmations.delete.title": "Padam hantaran?",
  "confirmations.delete_list.confirm": "Padam",
  "confirmations.delete_list.message": "Adakah anda pasti anda ingin memadam senarai ini secara kekal?",
  "confirmations.delete_list.title": "Padam senarai?",
  "confirmations.discard_edit_media.confirm": "Singkir",
  "confirmations.discard_edit_media.message": "Anda belum menyimpan perubahan pada penerangan atau pratonton media. Anda ingin membuangnya?",
  "confirmations.follow_to_list.confirm": "Ikut dan tambah ke senarai",
  "confirmations.follow_to_list.message": "Anda mesti mengikuti {name} untuk tambahkannya ke senarai.",
  "confirmations.follow_to_list.title": "Ikut pengguna?",
  "confirmations.logout.confirm": "Log keluar",
  "confirmations.logout.message": "Adakah anda pasti anda ingin log keluar?",
  "confirmations.logout.title": "Log keluar?",
  "confirmations.missing_alt_text.confirm": "Tambah teks alternatif",
  "confirmations.missing_alt_text.message": "Hantaran anda mempunyai media tanpa teks alternatif. Kandungan anda akan lebih mudah tercapai jika anda menambah keterangan.",
  "confirmations.missing_alt_text.secondary": "Hantar saja",
  "confirmations.missing_alt_text.title": "Tambah teks alternatif?",
  "confirmations.mute.confirm": "Redamkan",
  "confirmations.redraft.confirm": "Padam & rangka semula",
  "confirmations.redraft.message": "Adakah anda pasti anda ingin memadam hantaran ini dan gubal semula? Sukaan dan galakan akan hilang, dan balasan ke hantaran asal akan menjadi yatim.",
  "confirmations.redraft.title": "Padam & gubah semula hantaran?",
  "confirmations.unfollow.confirm": "Nyahikut",
  "content_warning.hide": "Sorok hantaran",
  "content_warning.show": "Tunjuk saja",
  "content_warning.show_more": "Tunjuk lebih",
  "conversation.delete": "Padam perbualan",
  "conversation.mark_as_read": "Tanda sudah dibaca",
  "conversation.open": "Lihat perbualan",
  "conversation.with": "Dengan {names}",
  "copy_icon_button.copied": "Disalin ke papan klip",
  "copypaste.copied": "Disalin",
  "copypaste.copy_to_clipboard": "Salin ke papan klip",
  "directory.federated": "Dari alam bersekutu yang diketahui",
  "directory.local": "Dari {domain} sahaja",
  "directory.new_arrivals": "Ketibaan baharu",
  "directory.recently_active": "Aktif baru-baru ini",
  "disabled_account_banner.account_settings": "Tetapan akaun",
  "disabled_account_banner.text": "Akaun anda {disabledAccount} telah dinyahaktif.",
  "dismissable_banner.community_timeline": "Inilah hantaran awam terkini daripada orang yang akaun dihos oleh {domain}.",
  "dismissable_banner.dismiss": "Ketepikan",
  "dismissable_banner.public_timeline": "Hantaran-hantaran awam terkini ini dari pengguna alam bersekutu yang diikuti oleh pengguna dari {domain}.",
  "domain_block_modal.block": "Sekat pelayan",
  "domain_block_modal.block_account_instead": "Sekat @{name} sahaja",
  "domain_block_modal.they_can_interact_with_old_posts": "Pengguna dari pelayan ini boleh berinteraksi dengan hantaran lama anda.",
  "domain_block_modal.they_cant_follow": "Pengguna dari pelayan ini tidak boleh mengikuti anda.",
  "domain_block_modal.they_wont_know": "Dia tidak akan tahu bahawa dia telah disekat.",
  "domain_block_modal.title": "Sekat domain?",
  "domain_block_modal.you_will_lose_num_followers": "Anda akan kehilangan {followersCount, plural, other {{followersCountDisplay} pengikut}} dan {followingCount, plural, other {{followingCountDisplay} ikutan}}.",
  "domain_block_modal.you_will_lose_relationships": "Anda akan kehilangan semua pengikut dan ikutan anda dari pelayan ini.",
  "domain_block_modal.you_wont_see_posts": "Anda tidak akan melihat hantaran atau pemberitahuan dari pengguna pada pelayan ini.",
  "domain_pill.activitypub_lets_connect": "Hal ini membolehkan anda berhubung dan berinteraksi bukan sahaja dengan pengguna Mastodon tetapi melintasi pelbagai aplikasi sosial juga.",
  "domain_pill.activitypub_like_language": "ActivityPub adalah seperti bahasa yang digunakan oleh Mastodon untuk berhubung dengan jaringan sosial lain.",
  "domain_pill.server": "Pelayan",
  "domain_pill.your_handle": "Pemegang anda:",
  "domain_pill.your_server": "Rumah maya anda, tempatnya hantaran anda disimpan. Tidak berkenan dengan yang ini? Pindah antara pelayan pada bila-bila masa dan bawa pengikut anda sekali.",
  "domain_pill.your_username": "Pengenal unik anda pada pelayan ini. Anda mungkin akan berkongsi nama pengguna dengan pengguna daripada pelayan lain.",
  "embed.instructions": "Benam hantaran ini di laman sesawang anda dengan menyalin kod berikut.",
  "embed.preview": "Begini rupanya nanti:",
  "emoji_button.activity": "Aktiviti",
  "emoji_button.clear": "Padam",
  "emoji_button.custom": "Tersuai",
  "emoji_button.flags": "Bendera",
  "emoji_button.food": "Makanan & Minuman",
  "emoji_button.label": "Masukkan emoji",
  "emoji_button.nature": "Alam Semula Jadi",
  "emoji_button.not_found": "Tiada emoji sepadan dijumpai",
  "emoji_button.objects": "Objek",
  "emoji_button.people": "Orang",
  "emoji_button.recent": "Kerap digunakan",
  "emoji_button.search": "Cari...",
  "emoji_button.search_results": "Hasil carian",
  "emoji_button.symbols": "Simbol",
  "emoji_button.travel": "Kembara & Tempat",
  "empty_column.account_hides_collections": "Pengguna ini telah memilih untuk tidak menyediakan informasi tersebut",
  "empty_column.account_suspended": "Akaun digantung",
  "empty_column.account_timeline": "Tiada hantaran di sini!",
  "empty_column.account_unavailable": "Profil tidak tersedia",
  "empty_column.blocks": "Anda belum menyekat sesiapa.",
  "empty_column.bookmarked_statuses": "Anda belum ada hantaran yang ditanda buku. Apabila anda menanda buku sesuatu, ia akan muncul di sini.",
  "empty_column.community": "Garis masa tempatan kosong. Tulislah secara awam untuk memulakan sesuatu!",
  "empty_column.direct": "Anda belum mempunyai sebarang sebutan peribadi lagi. Apabila anda menghantar atau menerima satu, ia akan dipaparkan di sini.",
  "empty_column.domain_blocks": "Belum ada domain yang disekat.",
  "empty_column.explore_statuses": "Tiada apa-apa yang sohor kini sekarang. Semaklah kemudian!",
  "empty_column.favourited_statuses": "Anda belum mempunyai sebarang hantaran sukaan lagi. Hantaran akan muncul di sini apabila disukai oleh anda.",
  "empty_column.favourites": "Hantaran ini belum disukai mana-mana pengguna lagi. Pengguna yang menyukai akan muncul di sini.",
  "empty_column.follow_requests": "Anda belum mempunyai permintaan ikutan. Ia akan terpapar di sini apabila ada nanti.",
  "empty_column.followed_tags": "You have not followed any hashtags yet. When you do, they will show up here.",
  "empty_column.hashtag": "Belum ada apa-apa dengan tanda pagar ini.",
  "empty_column.home": "Garis masa laman utama anda kosong! Ikuti lebih ramai orang untuk mengisinya. {suggestions}",
  "empty_column.list": "Tiada apa-apa di senarai ini lagi. Apabila ahli senarai ini menerbitkan hantaran baharu, ia akan dipaparkan di sini.",
  "empty_column.mutes": "Anda belum meredamkan sesiapa.",
  "empty_column.notifications": "Anda belum ada sebarang pemberitahuan. Apabila orang lain berinteraksi dengan anda, ia akan muncul di sini.",
  "empty_column.public": "Tiada apa-apa di sini! Tulis sesuatu secara awam, atau ikuti pengguna daripada pelayan lain secara manual untuk mengisinya",
  "error.unexpected_crash.explanation": "Disebabkan pepijat dalam kod kami atau masalah keserasian pelayar, halaman ini tidak dapat dipaparkan dengan betulnya.",
  "error.unexpected_crash.explanation_addons": "Halaman ini tidak dapat dipaparkan dengan betulnya. Ralat ini mungkin disebabkan oleh pemalam pelayar atau alatan penterjemahan automatik.",
  "error.unexpected_crash.next_steps": "Cuba segarkan semula halaman. Jika itu tidak membantu, anda masih boleh menggunakan Mastodon dengan pelayar yang berlainan atau aplikasi natif.",
  "error.unexpected_crash.next_steps_addons": "Cuba nyahdaya pemalam dan segarkan semula halaman. Jika itu tidak membantu, anda masih boleh menggunakan Mastodon dengan pelayar yang berlainan atau aplikasi natif.",
  "errors.unexpected_crash.copy_stacktrace": "Salin surih tindanan ke papan keratan",
  "errors.unexpected_crash.report_issue": "Laporkan masalah",
  "explore.suggested_follows": "Orang",
  "explore.trending_links": "Baru",
  "explore.trending_statuses": "Hantar",
  "explore.trending_tags": "-Hashtags",
  "filter_modal.added.context_mismatch_explanation": "Kumpulan penapis ini tidak terpakai pada konteks di mana anda mengakses hantaran ini. Jika anda ingin hantaran ini untuk ditapis dalam konteks ini juga, anda perlu menyunting penapis tersebut.",
  "filter_modal.added.context_mismatch_title": "Konteks tidak sepadan!",
  "filter_modal.added.expired_explanation": "Kumpulan filter ini telah tamat tempoh, anda perlu mengubah tarikh luput untuk melaksanakannya.",
  "filter_modal.added.expired_title": "Penapis tamat tempoh!",
  "filter_modal.added.review_and_configure": "Untuk menyemak dan menetap kumpulan penapis ini secara lanjut, pergi ke {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Tetapan penapis",
  "filter_modal.added.settings_link": "halaman tetapan",
  "filter_modal.added.short_explanation": "Hantaran ini telah ditambah kepada kumpulan penapis berikut: {title}.",
  "filter_modal.added.title": "Penapis ditambah!",
  "filter_modal.select_filter.context_mismatch": "tidak terpakai pada konteks ini",
  "filter_modal.select_filter.expired": "tamat tempoh",
  "filter_modal.select_filter.prompt_new": "Kumpulan baru: {name}",
  "filter_modal.select_filter.search": "Cari atau cipta",
  "filter_modal.select_filter.subtitle": "Gunakan kumpulan yang sedia ada atau mencipta kumpulan baru",
  "filter_modal.select_filter.title": "Tapiskan hantaran ini",
  "filter_modal.title.status": "Tapiskan sesuatu hantaran",
  "firehose.all": "Semua",
  "firehose.local": "Server ini",
  "firehose.remote": "Server lain",
  "follow_request.authorize": "Benarkan",
  "follow_request.reject": "Tolak",
  "follow_requests.unlocked_explanation": "Walaupun akaun anda tidak dikunci, kakitangan {domain} merasakan anda mungkin ingin menyemak permintaan ikutan daripada akaun ini secara manual.",
  "follow_suggestions.curated_suggestion": "",
  "follow_suggestions.dismiss": "Jangan papar lagi",
  "follow_suggestions.hints.featured": "Profil{domain.",
  "follow_suggestions.hints.friends_of_friends": "This profile is popular among the people you follow.",
  "follow_suggestions.hints.most_followed": ".",
  "follow_suggestions.personalized_suggestion": "Cadangan peribadi",
  "follow_suggestions.popular_suggestion": "Cadangan terkenal",
  "follow_suggestions.view_all": "Lihat semua",
  "followed_tags": "Topik terpilih",
  "footer.about": "Perihal",
  "footer.directory": "Direktori profil",
  "footer.get_app": "Dapatkan app",
  "footer.keyboard_shortcuts": "Pintasan papan kekunci",
  "footer.privacy_policy": "Dasar privasi",
  "footer.source_code": "Lihat kod sumber",
  "footer.status": "Status:",
  "generic.saved": "Disimpan",
  "getting_started.heading": "Mari bermula",
  "hashtag.column_header.tag_mode.all": "dan {additional}",
  "hashtag.column_header.tag_mode.any": "atau {additional}",
  "hashtag.column_header.tag_mode.none": "tanpa {additional}",
  "hashtag.column_settings.select.no_options_message": "Tiada cadangan dijumpai",
  "hashtag.column_settings.select.placeholder": "Masukkan tanda pagar…",
  "hashtag.column_settings.tag_mode.all": "Kesemua ini",
  "hashtag.column_settings.tag_mode.any": "Mana-mana daripada yang ini",
  "hashtag.column_settings.tag_mode.none": "Tiada apa pun daripada yang ini",
  "hashtag.column_settings.tag_toggle": "Sertakan tag tambahan untuk lajur ini",
  "hashtag.counter_by_accounts": "{count, plural, other {{counter} peserta}}",
  "hashtag.counter_by_uses": "{count, plural, other {{counter} siaran}}",
  "hashtag.counter_by_uses_today": "{count, plural, other {{counter} siaran}} hari ini",
  "hashtag.follow": "Ikuti hashtag",
  "hashtag.mute": "Redamkan #{hashtag}",
  "hashtag.unfollow": "Nyahikut tanda pagar",
  "hashtags.and_other": "…dan {count, plural, other {# more}}",
  "home.column_settings.show_reblogs": "Tunjukkan galakan",
  "home.column_settings.show_replies": "Tunjukkan balasan",
  "home.hide_announcements": "Sembunyikan pengumuman",
  "home.pending_critical_update.body": "Sila kemas kini pelayan Mastodon anda secepat yang mungkin!",
  "home.pending_critical_update.link": "Lihat pengemaskinian",
  "home.pending_critical_update.title": "Kemas kini keselamatan kritikal tersedia!",
  "home.show_announcements": "Tunjukkan pengumuman",
  "interaction_modal.on_another_server": "Di pelayan lain",
  "interaction_modal.on_this_server": "Pada pelayan ini",
  "intervals.full.days": "{number, plural, other {# hari}}",
  "intervals.full.hours": "{number, plural, other {# jam}}",
  "intervals.full.minutes": "{number, plural, other {# minit}}",
  "keyboard_shortcuts.back": "to navigate back",
  "keyboard_shortcuts.blocked": "Buka senarai pengguna tersekat",
  "keyboard_shortcuts.boost": "to boost",
  "keyboard_shortcuts.column": "Tumpu pada lajur",
  "keyboard_shortcuts.compose": "to focus the compose textarea",
  "keyboard_shortcuts.description": "Keterangan",
  "keyboard_shortcuts.down": "to move down in the list",
  "keyboard_shortcuts.enter": "Buka hantaran",
  "keyboard_shortcuts.favourite": "Suka hantaran",
  "keyboard_shortcuts.favourites": "Buka senarai sukaan",
  "keyboard_shortcuts.federated": "to open federated timeline",
  "keyboard_shortcuts.heading": "Pintasan papan kekunci",
  "keyboard_shortcuts.home": "to open home timeline",
  "keyboard_shortcuts.hotkey": "Kekunci pantas",
  "keyboard_shortcuts.legend": "to display this legend",
  "keyboard_shortcuts.local": "to open local timeline",
  "keyboard_shortcuts.mention": "to mention author",
  "keyboard_shortcuts.muted": "Buka senarai pengguna teredam",
  "keyboard_shortcuts.my_profile": "to open your profile",
  "keyboard_shortcuts.notifications": "to open notifications column",
  "keyboard_shortcuts.open_media": "to open media",
  "keyboard_shortcuts.pinned": "Buka senarai hantaran tersemat",
  "keyboard_shortcuts.profile": "to open author's profile",
  "keyboard_shortcuts.reply": "to reply",
  "keyboard_shortcuts.requests": "Buka senarai permintaan ikutan",
  "keyboard_shortcuts.search": "Tumpu pada bar gelintar",
  "keyboard_shortcuts.spoilers": "Tunjuk/sembunyi medan CW",
  "keyboard_shortcuts.start": "Buka lajur “mari bermula”",
  "keyboard_shortcuts.toggle_hidden": "Tunjuk/sembunyi teks di sebalik CW",
  "keyboard_shortcuts.toggle_sensitivity": "Tunjuk/sembunyi media",
  "keyboard_shortcuts.toot": "Mula hantaran baharu",
  "keyboard_shortcuts.unfocus": "to un-focus compose textarea/search",
  "keyboard_shortcuts.up": "Pindah ke atas dalam senarai",
  "lightbox.close": "Tutup",
  "lightbox.next": "Seterusnya",
  "lightbox.previous": "Sebelumnya",
  "limited_account_hint.action": "Paparkan profil",
  "limited_account_hint.title": "Profil ini telah disembunyikan oleh moderator {domain}.",
  "link_preview.author": "Dengan {name}",
  "lists.delete": "Padam senarai",
  "lists.edit": "Sunting senarai",
  "lists.replies_policy.followed": "Sesiapa yang diikuti",
  "lists.replies_policy.list": "Ahli-ahli dalam senarai",
  "lists.replies_policy.none": "Tiada sesiapa",
  "load_pending": "{count, plural, one {# item baharu} other {# item baharu}}",
  "loading_indicator.label": "Memuatkan…",
  "moved_to_account_banner.text": "Akaun anda {disabledAccount} kini dinyahdayakan kerana anda berpindah ke {movedToAccount}.",
  "mute_modal.indefinite": "Sehingga dinyahredamkan",
  "mute_modal.they_wont_know": "Dia tidak akan tahu bahawa dia telah diredam.",
  "mute_modal.title": "Redamkan pengguna?",
  "navigation_bar.about": "Perihal",
  "navigation_bar.advanced_interface": "Buka dalam antara muka web lanjutan",
  "navigation_bar.blocks": "Pengguna tersekat",
  "navigation_bar.bookmarks": "Tanda buku",
  "navigation_bar.direct": "Sebutan peribadi",
  "navigation_bar.domain_blocks": "Domain tersekat",
  "navigation_bar.favourites": "Sukaan",
  "navigation_bar.filters": "Perkataan teredam",
  "navigation_bar.follow_requests": "Permintaan ikutan",
  "navigation_bar.followed_tags": "Ikuti hashtag",
  "navigation_bar.follows_and_followers": "Ikutan dan pengikut",
  "navigation_bar.lists": "Senarai",
  "navigation_bar.logout": "Log keluar",
  "navigation_bar.mutes": "Pengguna teredam",
  "navigation_bar.opened_in_classic_interface": "Kiriman, akaun dan halaman tertentu yang lain dibuka secara lalai di antara muka web klasik.",
  "navigation_bar.preferences": "Keutamaan",
  "navigation_bar.search": "Cari",
  "not_signed_in_indicator.not_signed_in": "Anda perlu daftar masuk untuk mencapai sumber ini.",
  "notification.admin.report": "{name} melaporkan {target}",
  "notification.admin.sign_up": "{name} mendaftar",
  "notification.favourite": "{name} menyukai hantaran anda",
  "notification.favourite.name_and_others_with_link": "{name} dan <a>{count, plural, other {# orang lain}}</a> telah suka hantaran anda",
  "notification.favourite_pm": "{name} menyukai sebutan persendirian anda",
  "notification.favourite_pm.name_and_others_with_link": "{name} dan <a>{count, plural, other {# orang lain}}</a> telah suka sebutan persendirian anda",
  "notification.follow": "{name} mengikuti anda",
  "notification.follow_request": "{name} meminta untuk mengikuti anda",
  "notification.own_poll": "Undian anda telah tamat",
  "notification.reblog": "{name} menggalak hantaran anda",
  "notification.reblog.name_and_others_with_link": "{name} dan <a>{count, plural, other {# orang lain}}</a> telah galakkan hantaran anda",
  "notification.relationships_severance_event.domain_block": "Pentadbir dari {from} telah menyekat {target} termasuk {followersCount} pengikut anda dan {followingCount, plural, other {# akaun}} ikutan anda.",
  "notification.relationships_severance_event.user_domain_block": "Anda telah menyekat {target} termasuk {followersCount} pengikut anda dan {followingCount, plural, other {# akaun}} ikutan anda.",
  "notification.status": "{name} baru sahaja mengirim hantaran",
  "notification.update": "{name} menyunting hantaran",
  "notifications.clear": "Buang pemberitahuan",
  "notifications.clear_confirmation": "Adakah anda pasti anda ingin membuang semua pemberitahuan anda secara kekal?",
  "notifications.column_settings.admin.report": "Laporan baru:",
  "notifications.column_settings.admin.sign_up": "Pendaftaran baru:",
  "notifications.column_settings.alert": "Pemberitahuan atas meja",
  "notifications.column_settings.favourite": "Sukaan:",
  "notifications.column_settings.follow": "Pengikut baharu:",
  "notifications.column_settings.follow_request": "Permintaan ikutan baharu:",
  "notifications.column_settings.mention": "Sebutan:",
  "notifications.column_settings.poll": "Keputusan undian:",
  "notifications.column_settings.push": "Pemberitahuan tolak",
  "notifications.column_settings.reblog": "Galakan:",
  "notifications.column_settings.show": "Tunjukkan dalam lajur",
  "notifications.column_settings.sound": "Mainkan bunyi",
  "notifications.column_settings.status": "Hantaran baharu:",
  "notifications.column_settings.unread_notifications.category": "Pemberitahuan belum dibaca",
  "notifications.column_settings.unread_notifications.highlight": "Serlahkan pemberitahuan yang belum dibaca",
  "notifications.column_settings.update": "Suntingan:",
  "notifications.filter.all": "Semua",
  "notifications.filter.boosts": "Galakan",
  "notifications.filter.favourites": "Sukaan",
  "notifications.filter.follows": "Ikutan",
  "notifications.filter.mentions": "Sebutan",
  "notifications.filter.polls": "Keputusan undian",
  "notifications.filter.statuses": "Kemaskini dari orang yang anda ikuti",
  "notifications.grant_permission": "Beri kebenaran.",
  "notifications.group": "{count} pemberitahuan",
  "notifications.mark_as_read": "Tandakan semua pemberitahuan sebagai sudah dibaca",
  "notifications.permission_denied": "Pemberitahuan atas meja tidak tersedia kerana permintaan kebenaran pelayar sebelum ini ditolak",
  "notifications.permission_denied_alert": "Pemberitahuan atas meja tidak boleh didayakan, kerana permintaan kebenaran pelayar sebelum ini ditolak",
  "notifications.permission_required": "Pemberitahuan atas meja tidak tersedia kerana permintaan kebenaran masih belum diberikan.",
  "notifications_permission_banner.enable": "Dayakan pemberitahuan atas meja",
  "notifications_permission_banner.how_to_control": "Untuk mendapat pemberitahuan ketika Mastodon tidak dibuka, dayakan pemberitahuan atas meja. Anda boleh mengawal jenis interaksi mana yang menjana pemberitahuan atas meja melalui butang {icon} di atas setelah ia didayakan.",
  "notifications_permission_banner.title": "Jangan terlepas apa-apa",
  "onboarding.follows.empty": "Malangnya, tiada hasil dapat ditunjukkan sekarang. Anda boleh cuba menggunakan carian atau menyemak imbas halaman teroka untuk mencari orang untuk diikuti atau cuba lagi kemudian.",
  "onboarding.profile.display_name": "Nama paparan",
  "onboarding.profile.display_name_hint": "Nama penuh anda atau nama anda yang menyeronokkan…",
  "onboarding.profile.note_hint": "Anda boleh @menyebut orang lain atau #hashtags…",
  "onboarding.profile.upload_avatar": "Muat naik gambar profil",
  "password_confirmation.exceeds_maxlength": "Pengesahan kata laluan melebihi panjang kata laluan maksimum",
  "password_confirmation.mismatching": "Pengesahan kata laluan tidak sepadan",
  "picture_in_picture.restore": "Letak semula",
  "poll.closed": "Ditutup",
  "poll.refresh": "Muat semula",
  "poll.reveal": "Hasil carian",
  "poll.total_people": "{count, plural, other {# orang}}",
  "poll.total_votes": "{count, plural, other {# undian}}",
  "poll.vote": "Undi",
  "poll.voted": "Anda mengundi jawapan ini",
  "poll.votes": "{votes, plural, other {# undi}}",
  "poll_button.add_poll": "Tambah undian",
  "poll_button.remove_poll": "Buang undian",
  "privacy.change": "Ubah privasi hantaran",
  "privacy.direct.long": "Semua orang yang disebutkan dalam siaran",
  "privacy.private.long": "Pengikut anda sahaja",
  "privacy.private.short": "Pengikut",
  "privacy.public.short": "Awam",
  "privacy_policy.last_updated": "Dikemaskini {date}",
  "privacy_policy.title": "Dasar Privasi",
  "recommended": "Disyorkan",
  "refresh": "Muat semula",
  "relative_time.days": "{number}h",
  "relative_time.full.days": "{number, plural, other {# hari}} yang lalu",
  "relative_time.full.hours": "{number, plural, other {# jam}} yang lalu",
  "relative_time.full.just_now": "sebentar tadi",
  "relative_time.full.minutes": "{number, plural, other {# minit}} yang lalu",
  "relative_time.full.seconds": "{number, plural, other {# saat}} yang lalu",
  "relative_time.hours": "{number}j",
  "relative_time.just_now": "sekarang",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "hari ini",
  "reply_indicator.attachments": "{count, plural, other {# lampiran}}",
  "reply_indicator.cancel": "Batal",
  "reply_indicator.poll": "Undian",
  "report.block": "Sekat",
  "report.block_explanation": "Anda tidak akan melihat hantarannya. Dia tidak akan dapat melihat hantaran anda atau mengikuti anda. Dia akan sedar bahawa dia disekat.",
  "report.categories.legal": "Sah",
  "report.categories.other": "Lain-lain",
  "report.categories.spam": "Spam",
  "report.categories.violation": "Kandungan melanggar satu atau lebih peraturan pelayan",
  "report.category.subtitle": "Pilih yang terdekat",
  "report.category.title": "Beritahu kami apa yang berlaku dengan {type} ini",
  "report.category.title_account": "profil",
  "report.category.title_status": "siaran",
  "report.close": "Selesai",
  "report.comment.title": "Adakah ada hal-hal lain yang perlu kita ketahui?",
  "report.forward": "Panjangkan ke {target}",
  "report.forward_hint": "Akaun ini daripada pelayan lain. Hantar salinan laporan yang ditanpanamakan ke sana juga?",
  "report.mute": "Redam",
  "report.mute_explanation": "Anda tidak akan melihat siaran mereka. Mereka masih boleh mengikuti dan melihat siaran anda dan tidak akan mengetahui bahawa mereka telah dibisukan.",
  "report.next": "Seterusnya",
  "report.placeholder": "Ulasan tambahan",
  "report.reasons.dislike": "Saya tidak suka",
  "report.reasons.dislike_description": "Inilah sesuatu yang anda tidak ingin lihat",
  "report.reasons.legal": "Ia haram",
  "report.reasons.legal_description": "Anda percaya ia melanggar undang-undang negara anda atau negara server",
  "report.reasons.other": "Inilah sesuatu yang lain",
  "report.reasons.other_description": "Isu ini tidak sesuai untuk kategori lain",
  "report.reasons.spam": "Inilah spam",
  "report.reasons.spam_description": "Pautan berbahaya, keterlibatan palsu atau balasan berulang",
  "report.reasons.violation": "Ini melanggar peraturan pelayan",
  "report.reasons.violation_description": "Anda menyedari bahawa ini melanggar peraturan yang tertentu",
  "report.rules.subtitle": "Pilih semua yang berkenaan",
  "report.rules.title": "Peraturan-peraturan manakah yang telah dilanggar?",
  "report.statuses.subtitle": "Pilih semua yang berkenaan",
  "report.statuses.title": "Adakah terdapat siaran-siaran lain yang dapat menyokong laporan ini?",
  "report.submit": "Serah",
  "report.target": "Melaporkan {target}",
  "report.thanks.take_action": "Berikut ialah pilihan anda untuk mengawal apa yang anda lihat di Mastodon:",
  "report.thanks.take_action_actionable": "Sementara kami menyemak ini, anda boleh mengambil tindakan terhadap @{name}:",
  "report.thanks.title": "Tidak ingin melihat ini?",
  "report.thanks.title_actionable": "Terima kasih untuk laporan anda, kami akan menyemaknya.",
  "report.unfollow": "Nyahikut @{name}",
  "report.unfollow_explanation": "Anda sedang mengikuti akaun ini. Untuk memadam siaran mereka daripada suapan berita anda, nyahikutkan mereka.",
  "report_notification.attached_statuses": "{count, plural, other {{count} hantaran}} dilampirkan",
  "report_notification.categories.legal": "Sah",
  "report_notification.categories.other": "Lain-lain",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.violation": "Langgaran peraturan",
  "report_notification.open": "Buka laporan",
  "search.no_recent_searches": "Tiada carian terkini",
  "search.placeholder": "Cari",
  "search.quick_action.account_search": "Pos sepadan {x}",
  "search.quick_action.go_to_account": "Pergi ke profil {x}",
  "search.quick_action.go_to_hashtag": "Pergi ke hashtag {x}",
  "search.quick_action.open_url": "Buka URL dalam Mastadon",
  "search.quick_action.status_search": "Pos sepadan {x}",
  "search.search_or_paste": "Cari atau tampal URL",
  "search_popout.full_text_search_disabled_message": "Tidak tersedia di {domain}.",
  "search_popout.language_code": "Kod bahasa ISO",
  "search_popout.options": "Pilihan carian",
  "search_popout.quick_actions": "Tindakan pantas",
  "search_popout.recent": "Carian terkini",
  "search_popout.specific_date": "tarikh tertentu",
  "search_popout.user": "pengguna",
  "search_results.accounts": "Profil",
  "search_results.all": "Semua",
  "search_results.hashtags": "Tanda pagar",
  "search_results.see_all": "Lihat semua",
  "search_results.statuses": "Hantaran",
  "server_banner.about_active_users": "Pengguna pelayan ini sepanjang 30 hari yang lalu (Pengguna Aktif Bulanan)",
  "server_banner.active_users": "pengguna aktif",
  "server_banner.administered_by": "Ditadbir oleh:",
  "server_banner.server_stats": "Statistik pelayan:",
  "sign_in_banner.create_account": "Cipta akaun",
  "sign_in_banner.sign_in": "Daftar masuk",
  "sign_in_banner.sso_redirect": "Log masuk atau mendaftar",
  "status.admin_account": "Buka antara muka penyederhanaan untuk @{name}",
  "status.admin_domain": "antara muka penyederhanaan",
  "status.admin_status": "Buka hantaran ini dalam antara muka penyederhanaan",
  "status.block": "Sekat @{name}",
  "status.bookmark": "Tanda buku",
  "status.cancel_reblog_private": "Nyahgalakkan",
  "status.cannot_reblog": "Hantaran ini tidak boleh digalakkan",
  "status.copy": "Salin pautan ke hantaran",
  "status.delete": "Padam",
  "status.detailed_status": "Paparan perbualan terperinci",
  "status.direct": "Sebut secara peribadi @{name}",
  "status.direct_indicator": "Sebutan peribadi",
  "status.edit": "Sunting",
  "status.edited_x_times": "Disunting {count, plural, other {{count} kali}}",
  "status.favourite": "Suka",
  "status.filter": "Tapiskan hantaran ini",
  "status.history.created": "{name} mencipta pada {date}",
  "status.history.edited": "{name} menyunting pada {date}",
  "status.load_more": "Muatkan lagi",
  "status.media.open": "Klik untuk membuka",
  "status.media.show": "Klik untuk menunjukkan",
  "status.media_hidden": "Media disembunyikan",
  "status.mention": "Sebut @{name}",
  "status.more": "Lagi",
  "status.mute": "Redamkan @{name}",
  "status.mute_conversation": "Redamkan perbualan",
  "status.open": "Kembangkan hantaran ini",
  "status.pin": "Semat di profil",
  "status.read_more": "Baca lagi",
  "status.reblog": "Galakkan",
  "status.reblogged_by": "{name} galakkan",
  "status.reblogs.empty": "Tiada sesiapa yang galakkan hantaran ini. Apabila ada yang galakkan, hantaran akan muncul di sini.",
  "status.redraft": "Padam & rangka semula",
  "status.remove_bookmark": "Buang tanda buku",
  "status.remove_favourite": "Padam dari sukaan",
  "status.replied_to": "Menjawab kepada {name}",
  "status.reply": "Balas",
  "status.replyAll": "Balas ke bebenang",
  "status.report": "Laporkan @{name}",
  "status.sensitive_warning": "Kandungan sensitif",
  "status.share": "Kongsi",
  "status.show_less_all": "Tunjukkan kurang untuk semua",
  "status.show_more_all": "Tunjukkan lebih untuk semua",
  "status.show_original": "Paparkan yang asal",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.translate": "Menterjemah",
  "status.translated_from_with": "Diterjemah daripada {lang} dengan {provider}",
  "status.uncached_media_warning": "Pratonton tidak tersedia",
  "status.unmute_conversation": "Nyahredamkan perbualan",
  "status.unpin": "Nyahsemat daripada profil",
  "subscribed_languages.lead": "Hanya hantaran dalam bahasa-bahasa terpilih akan dipaparkan pada garis masa rumah dan senarai selepas perubahan. Pilih tiada untuk menerima hantaran dalam semua bahasa.",
  "subscribed_languages.save": "Simpan perubahan",
  "subscribed_languages.target": "Tukar bahasa-bahasa dilanggan untuk {target}",
  "tabs_bar.home": "Laman utama",
  "tabs_bar.notifications": "Pemberitahuan",
  "time_remaining.days": "Tinggal {number, plural, other {# hari}}",
  "time_remaining.hours": "Tinggal {number, plural, other {# jam}}",
  "time_remaining.minutes": "Tinggal {number, plural, other {# minit}}",
  "time_remaining.moments": "Tinggal beberapa saat",
  "time_remaining.seconds": "Tinggal {number, plural, other {# saat}}",
  "trends.counter_by_accounts": "{count, plural, other {{counter} orang}} dalam {days, plural, other {{days} hari}} yang lalu",
  "trends.trending_now": "Sohor kini",
  "ui.beforeunload": "Rangka anda akan terhapus jika anda meninggalkan Mastodon.",
  "units.short.billion": "{count}B",
  "units.short.million": "{count}J",
  "units.short.thousand": "{count}R",
  "upload_area.title": "Seret & letak untuk muat naik",
  "upload_button.label": "Tambah fail imej, video atau audio",
  "upload_error.limit": "Sudah melebihi had muat naik.",
  "upload_error.poll": "Tidak boleh memuat naik fail bersama undian.",
  "upload_form.drag_and_drop.instructions": "Untuk mengangkat lampiran media, tekan jarak atau enter. Ketika menarik, gunakan kekunci anak panah untuk menggerakkan lampiran media pada mana-mana arah. Tekan jarak atau enter untuk melepaskan lampiran media pada kedudukan baharunya, atau tekan keluar untuk batalkan.",
  "upload_form.drag_and_drop.on_drag_cancel": "Seretan dibatalkan. Lampiran media {item} dilepaskan.",
  "upload_form.edit": "Sunting",
  "upload_progress.label": "Memuat naik...",
  "upload_progress.processing": "Memproses…",
  "username.taken": "Nama pengguna tersebut sudah digunakan. Sila cuba lagi",
  "video.close": "Tutup video",
  "video.download": "Muat turun fail",
  "video.exit_fullscreen": "Keluar skrin penuh",
  "video.expand": "Besarkan video",
  "video.fullscreen": "Skrin penuh",
  "video.hide": "Sembunyikan video",
  "video.mute": "Redam",
  "video.pause": "Jeda",
  "video.play": "Main",
  "video.unmute": "Nyahredam"
}
